var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.handleScroll),expression:"handleScroll"}],staticClass:"second-box"},[_c('img',{staticClass:"second-box__img",attrs:{"src":require("../../../assets/arima/ko_arima1.jpg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }